import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {PermissionSetContainerModel} from '../../../../../models/aggregates/permissions';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';

// https://api.akaun.com/core2/tnt/dm/iam/app-permission-sets/applet-login-ep/

@Injectable({
  providedIn: 'root'
})
export class PermissionSetLoginEPService extends BaseApiTemplateService<PermissionSetContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-permission-sets/applet-login-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-permission-sets/applet-login-ep';
    this.httpClient = http;
  }

  public postByAppletLogin(dtoObject: PermissionSetContainerModel, appletGuid: string, visa: ApiVisa): Observable<ApiResponseModel<PermissionSetContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const urlByLogin = this.apiUrl + '/' + appletGuid;
    return this.httpClient.post<ApiResponseModel<PermissionSetContainerModel>>(
      urlByLogin,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  public putByAppletLogin(dtoObject: PermissionSetContainerModel, appletGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<PermissionSetContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const urlByLogin = this.apiUrl + '/' + appletGuid;
    return this.httpClient.put<BasicApiResponseModel<PermissionSetContainerModel>>(
      urlByLogin,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public deleteByAppletLogin(appletGuid: string, guid: string, visa: ApiVisa): Observable<ApiResponseModel<PermissionSetContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const urlByLogin = this.apiUrl + '/' + appletGuid + '/'+ guid;
    return this.httpClient.delete<ApiResponseModel<PermissionSetContainerModel>>(
      urlByLogin,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidByAppletLogin(
    appletGuid: string,
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<PermissionSetContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const urlByLogin = this.apiUrl + '/' + appletGuid + '/'+ guid;
    return this.httpClient.get<BasicApiResponseModel<PermissionSetContainerModel>>(
      urlByLogin,
      this.getHttpHeader(visa)
    );
  }

  public getByAppletLogin(appletGuid: string, visa: ApiVisa): Observable<ApiResponseModel<PermissionSetContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const urlByLogin = this.apiUrl + '/' + appletGuid;
    return this.httpClient.get<ApiResponseModel<PermissionSetContainerModel>>(
      urlByLogin,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    guid: any,
  ): Observable<PagingResponseModel<PermissionSetContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl +'/'+ guid + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PermissionSetContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }


}


